import { useEffect, useState } from 'react'
import { Container, FlexIcon } from './styles'
import { appApi } from '../../../../../services/appApi'
import { FaClipboardList, FaMapMarkerAlt } from 'react-icons/fa'
import { iCardEtapa } from '../../../../../interfaces'
import { PropInvalida } from '../../../../../Utils/Helper'
interface iCardReuniao {
  etapa: iCardEtapa
  isOpen: boolean
}

interface iModel {
  descricao: string
  local: string
}

export const CardNovaReuniaoOne: React.FC<iCardReuniao> = ({ etapa, isOpen }) => {
  const [Model, setModel] = useState<iModel>()

  function ObterEtapa(): void {
    appApi.get(`ReuniaoOneEtapa/${etapa.id ?? ''}/Detalhe`)
      .then(res => {
        setModel(res.data)
      })
      .catch(err => console.log(err))
  }

  useEffect(() => {
    if (isOpen && PropInvalida(Model)) {
      ObterEtapa()
    }
  }, [isOpen])

  return (
    <Container>
      <FlexIcon>
        <FaMapMarkerAlt size={20} />
        <div>
          <h4>Local da reunião</h4>
          <strong>{Model?.local}</strong>
        </div>
      </FlexIcon>

      {Model?.descricao !== null && (
          <FlexIcon>
            <FaClipboardList size={20} />
            <div>
              <h4>Descrição</h4>
              <small dangerouslySetInnerHTML={{ __html: Model?.descricao ?? '' }}></small>
            </div>
          </FlexIcon>
      )
      }
    </Container>
  )
}
